export default __webpack_public_path__ + "static/media/background.d5fbef65.jpeg";